import validate from "/usr/src/app/content/n3-redirections-spa-6b86099d-09a5-4b74-8bb2-1bfa3d28c26c/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-redirections-spa-6b86099d-09a5-4b74-8bb2-1bfa3d28c26c/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}